var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgram2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M487.76 161.94C484.17 148.85 455.47 44.12 451.88 31.03C449.94 25.21 444.12 24.24 440.24 28.12C429.25 38.79 374.3 92.12 275.39 188.12C133.43 227.1 54.56 248.76 38.79 253.09C12.61 259.88 -2.91 288 3.88 314.18C6.5 323.68 27.44 399.71 30.06 409.21C36.85 435.39 64.97 450.91 91.15 444.12C93.8 443.41 107.05 439.85 130.91 433.45C179.2 539.35 206.03 598.17 211.39 609.94C212.36 612.85 216.24 614.79 220.12 613.82C229.43 611.3 303.9 591.13 313.21 588.61C317.09 587.64 320 582.79 318.06 578.91C316.9 576.52 311.08 564.56 300.61 543.03C317.48 538.38 326.85 535.79 328.73 535.27C332.61 534.3 335.52 529.45 333.58 525.58C330.28 518.5 303.9 461.87 300.61 454.79C298.67 451.88 295.76 449.94 291.88 450.91C289.87 451.43 279.85 454.01 261.82 458.67L236.61 404.36L327.76 379.15C461.58 411.73 535.92 429.83 550.79 433.45C556.61 434.42 561.45 429.58 559.52 424.73C555.93 411.73 527.22 307.78 523.64 294.79C557.58 282.18 576 245.33 566.3 211.39C556.61 177.45 522.67 156.12 487.76 161.94ZM316.12 523.64L293.82 529.45L267.64 472.24L289.94 466.42L316.12 523.64ZM43.64 405.33C41.02 395.83 20.07 319.81 17.45 310.3C12.61 291.88 23.27 272.48 41.7 267.64C57.21 263.37 134.79 242.04 274.42 203.64C301.19 301.38 316.06 355.68 319.03 366.55C249.21 385.94 132.85 417.94 87.27 430.55C67.88 435.39 48.48 424.73 43.64 405.33ZM221.09 598.3C175.13 497.07 149.59 440.82 144.48 429.58C151.27 427.64 210.42 411.15 223.03 408.24C228.14 419.49 253.67 475.73 299.64 576.97L221.09 598.3ZM287.03 196.85L441.21 47.52L543.03 416.97L333.58 365.58L287.03 196.85ZM491.64 175.52C518.79 171.64 544.97 188.12 551.76 215.27C559.52 242.42 545.94 270.55 520.73 280.24C514.91 259.3 494.55 185.99 491.64 175.52Z",
    id: "a20HoSZpSt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.33 186.18C627.01 186.86 608.39 192.29 606.06 192.97C602.18 193.94 600.24 197.82 601.21 201.7C602.18 205.58 606.06 207.52 609.94 206.55C612.27 205.87 630.88 200.44 633.21 199.76C636.12 198.79 639.03 194.91 638.06 191.03C637.09 187.15 633.21 185.21 629.33 186.18Z",
    id: "b200LzmuMm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.52 107.64C558.35 109.77 549.04 126.84 547.88 128.97C545.94 132.85 546.91 136.73 550.79 138.67C554.67 140.61 558.55 139.64 560.48 135.76C561.65 133.62 570.96 116.56 572.12 114.42C574.06 110.55 573.09 106.67 569.21 104.73C565.33 102.79 561.45 103.76 559.52 107.64Z",
    id: "f1lboB967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.21 279.27C597.33 277.33 593.45 278.3 591.52 282.18C589.58 286.06 590.55 289.94 594.42 291.88C596.56 293.04 613.62 302.35 615.76 303.52C619.64 305.45 623.52 304.48 625.45 300.61C626.42 296.73 625.45 292.85 621.58 290.91C617.5 288.58 603.25 280.44 601.21 279.27Z",
    id: "f2Be9vziBi"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a20HoSZpSt",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a20HoSZpSt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b200LzmuMm",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b200LzmuMm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1lboB967",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f1lboB967",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2Be9vziBi",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f2Be9vziBi",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram2);
export default __webpack_public_path__ + "static/media/program-2.213ee40dd2fd1475e5cb76dad0f566ca.svg";
export { ForwardRef as ReactComponent };